import { Category } from 'src/app/models/category';
import { IRepository } from 'src/app/repositories/interface.repository';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CoreResponseMessage } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { BaseRepository, OrderBy } from 'src/app/repositories/base.repository';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { Injectable } from "@angular/core";

export enum CategorySortBy {
    Name
}

@Injectable()
export class CategoryRepository extends BaseRepository implements IRepository {
    
    constructor(public http: HttpClient, public functionService: FunctionsService, public clientConfig: ClientConfigService) {
        super(http, functionService, clientConfig, 'Category');
    }

    async getAsync(headers: HttpHeaders, ids: number[]): Promise<CoreResponseMessage> {
        let categories: Category[] = [];
        return new CoreResponseMessage();
    }

    async addAsync(headers: HttpHeaders, addCategories: Category[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Add', JSON.stringify(addCategories), {headers}).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }

    async updateAsync(headers: HttpHeaders, updateCategory: Category): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Update', updateCategory, {headers}).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }

    async removeAsync(headers: HttpHeaders, categoryId: number[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Remove', JSON.stringify(categoryId), {headers}).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }

    async getAllAsync(headers: HttpHeaders, pageIndex: number, pageSize: number, sortBy: CategorySortBy, orderBy: OrderBy): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        //responseMsg = this.createCategories();
        const params = new HttpParams().set('pageIndex', pageIndex.toString())
                                       .set('pageSize', pageSize.toString())
                                       .set('sortBy', sortBy.toString())
                                       .set('orderBy', orderBy.toString());
        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'GetAll', {headers, params}).toPromise().then(resp => {
            responseMsg = resp;    
        }).catch(err => {
            responseMsg = err.error;        
        });

        return responseMsg;
    }

    private createCategories(): CoreResponseMessage {        
        let categories: Category[] = [];
        let coreRespMsg: CoreResponseMessage;

        categories.push({
            Id: 1,
            UserId: 1,    
            Name: 'News',
            Channels: [
                {
                    Id: 1,
                    UserId: 1,
                    ChannelUrl: 'http://feeds.bbci.co.uk/news/rss.xml?edition=uk',
                    Title: 'BBC',
                    PublishDate: null,
                    ImageUrl: 'http://localhost:4200/assets/ultrarss.png',
                    Active: true,
                    Show: true,
                    ModifiedDate: null,
                    CreatedDate: null,
                    Categories: null
                },
                {
                    Id: 1,
                    UserId: 1,
                    ChannelUrl: 'https://www.engadget.com/rss.xml',
                    Title: 'Engadget',
                    PublishDate: null,                    
                    ImageUrl: 'https://icdn3.digitaltrends.com/image/digitaltrends/dt-symbol-black-190621-2-32x32.jpg',
                    Active: true,
                    Show: true,
                    ModifiedDate: null,
                    CreatedDate: null,
                    Categories: null
                },
                {
                    Id: 1,
                    UserId: 1,
                    ChannelUrl: 'http://www.phonearena.com/feed',
                    Title: 'Phone Arena',
                    PublishDate: null,
                    ImageUrl: 'https://www.phonearena.com/img/logo-en.gif',
                    Active: true,
                    Show: true,
                    ModifiedDate: null,
                    CreatedDate: null,
                    Categories: null
                }
            ],
            Description: 'News description',
            Active: true,
            ModifiedDate: null,
            CreatedDate: null           
        });

        categories.push({
            Id: 1,
            UserId: 1,    
            Name: 'Technology',
            Channels: null,
            Description: 'Technology description',
            Active: true,
            ModifiedDate: null,
            CreatedDate: null           
        });

        categories.push({
            Id: 1,
            UserId: 1,    
            Name: 'Automobile',
            Channels: null,
            Description: 'Automobile description',
            Active: true,
            ModifiedDate: null,
            CreatedDate: null           
        });

        categories.push({
            Id: 1,
            UserId: 1,    
            Name: 'Miscallaneous',
            Channels: null,
            Description: 'Miscellaneous description',
            Active: true,
            ModifiedDate: null,
            CreatedDate: null           
        });

        coreRespMsg.Result = categories;
        coreRespMsg.TotalDataCount = 4;

        return coreRespMsg;
    }
}